export enum EVehicleType
{
    TemporaryData,
    OwnVehicle,
    HiredVehicle,
}
